/** @jsx builderX.jsx */

import {builderX, Sprite, Image} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name="waterMark_desktop">
        <Sprite name="balanceContainer">
            <Sprite name="labelBalanceContainer"/>
        </Sprite>
        <Sprite name="clockContainer">
            <Image position={[-460, -90]} name="bgTop" src="clocks_bg"/>
            <Image position={[-283, -73]} name="ui_timer_icon" src="ui_timer_icon"/>
            <Sprite position={[-115, -75]} name="labelClockContainer"/>
        </Sprite>
        <Sprite name="globalClockContainer">
            <Sprite position={[-100, -80]} name="labelClockContainer"/>
        </Sprite>
        <Sprite name="gameNameContainer">
            <Sprite position={[0, -24]} name="labelContainer"/>
        </Sprite>
        <Sprite name="sessionEarningsContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite name="sessionBetsContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite name="maxWinProbabilityContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite position={[ -125, -140]} name="RTPContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
    </Sprite>
);
